'use strict';

function setChainableConstructor(sugarNamespace, createFn) {
  sugarNamespace.prototype.constructor = function() {
    return createFn.apply(this, arguments);
  };
}

module.exports = setChainableConstructor;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/setChainableConstructor.js
// module id = 146
// module chunks = 1